<template>
  <div class="change-school-container">
    <div class="page-header mb-4">
      <div class="breadcrumb mb-2">ໜ້າຫຼັກ / <span>ປ່ຽນໂຮງຮຽນ</span></div>
      <div class="header-content">
        <h1 class="mb-1">ປ່ຽນໂຮງຮຽນ</h1>
        <p class="mb-0 text-muted">ເລືອກໂຮງຮຽນທີ່ທ່ານຕ້ອງການຈັດການຂໍ້ມູນ</p>
      </div>
    </div>

    <div class="panel shadow-sm">
      <div class="panel-head d-flex justify-content-between align-items-center flex-wrap">
        <h3 class="mb-0"><i class="fas fa-school mr-2"></i> ລາຍຊື່ໂຮງຮຽນ</h3>
        <div class="search-box">
          <i class="fas fa-search"></i>
          <input
            type="text"
            v-model="search"
            @input="onSearchInput"
            placeholder="ຄົ້ນຫາຕາມຊື່ ຫຼື ລະຫັດໂຮງຮຽນ..."
          />
        </div>
      </div>
      <div class="panel-body">
        <div v-if="loading" class="text-center py-5">
          <b-spinner variant="primary"></b-spinner>
          <p class="mt-2">ກຳລັງໂຫຼດຂໍ້ມູນ...</p>
        </div>

        <div v-else-if="schools.length === 0" class="text-center py-5 text-muted">
          <i class="fas fa-inbox fa-2x mb-2"></i>
          <p class="mb-0">ບໍ່ພົບຂໍ້ມູນໂຮງຮຽນ</p>
        </div>

        <div v-else>
          <div class="row">
            <div v-for="school in schools" :key="school._id" class="col-md-6 col-lg-4 mb-4">
              <div
                class="school-card shadow-sm"
                :class="{ 'active': currentSchoolId === school.school_id }"
                @click="selectSchool(school)"
              >
                <div class="school-icon">
                  <i class="fas fa-university"></i>
                </div>
                <div class="school-info">
                  <h4 class="mb-1">{{ school.school_name_lao }}</h4>
                  <p class="mb-0 text-muted small">EMIS Code: {{ school.school_id }}</p>
                  <p class="mb-0 text-muted small" v-if="school.district_name_lao">
                    {{ school.district_name_lao }}, {{ school.prov_name }}
                  </p>
                </div>
                <div class="status-indicator">
                  <i v-if="currentSchoolId === school.school_id" class="fas fa-check-circle text-success"></i>
                  <i v-else class="far fa-circle text-light"></i>
                </div>
              </div>
            </div>
          </div>

          <div class="pagination-bar" v-if="totalRows > limit">
            <span class="pagination-info">
              ສະແດງ {{ (page - 1) * limit + 1 }}-{{ rangeEnd }} ຈາກ {{ totalRows }} ໂຮງຮຽນ
            </span>
            <div class="pagination-actions">
              <button class="page-btn" :disabled="page <= 1" @click="changePage(page - 1)">
                ‹ ກ່ອນໜ້າ
              </button>
              <span class="page-current">ໜ້າ {{ page }} / {{ totalPages }}</span>
              <button class="page-btn" :disabled="page * limit >= totalRows" @click="changePage(page + 1)">
                ຕໍ່ໄປ ›
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api';

export default {
  data() {
    return {
      schools: [],
      loading: true,
      currentSchoolId: null,
      user: null,
      search: '',
      page: 1,
      limit: 30,
      totalRows: 0,
      searchTimer: null
    };
  },
  computed: {
    rangeEnd() {
      return Math.min(this.page * this.limit, this.totalRows);
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.totalRows / this.limit));
    }
  },
  created() {
    const userInfo = localStorage.getItem('user-info') || localStorage.getItem('Login');
    if (userInfo) {
      this.user = JSON.parse(userInfo);
      this.currentSchoolId = this.user.school_id;
    }
    this.fetchSchools();
  },
  methods: {
    async fetchSchools() {
      this.loading = true;
      try {
        // ດຶງລາຍຊື່ໂຮງຮຽນຈາກ collection schools (ມີ search + pagination)
        const res = await api.get('/schools/all', {
          params: {
            page: this.page,
            limit: this.limit,
            search: this.search
          }
        });
        if (res.data && res.data.code === 1) {
          this.schools = res.data.rows;
          this.totalRows = res.data.totalRows || 0;
        }
      } catch (e) {
        console.error('Error fetching schools:', e);
      } finally {
        this.loading = false;
      }
    },
    onSearchInput() {
      // Debounce: ລໍຖ້າ 400ms ຫຼັງຢຸດພິມ ຈຶ່ງຄົ້ນຫາ
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.fetchSchools();
      }, 400);
    },
    changePage(newPage) {
      this.page = newPage;
      this.fetchSchools();
    },
    selectSchool(school) {
      if (this.currentSchoolId === school.school_id) return;

      // ອັບເດດຂໍ້ມູນໃນ Local Storage
      const updatedUser = { ...this.user, school_id: school.school_id, school_name: school.school_name_lao };
      localStorage.setItem('user-info', JSON.stringify(updatedUser));
      localStorage.setItem('Login', JSON.stringify(updatedUser));

      this.currentSchoolId = school.school_id;

      alert(`ປ່ຽນເປັນໂຮງຮຽນ ${school.school_name_lao} ສຳເລັດ`);

      // Reload ລະບົບເພື່ອໃຫ້ຂໍ້ມູນ Dashboard ອັບເດດຕາມໂຮງຮຽນໃໝ່
      this.$router.push('/home/dashboard').then(() => {
        window.location.reload();
      });
    }
  }
};
</script>

<style scoped>
.change-school-container {
  animation: fadeIn 0.4s ease-out;
  max-width: 1200px;
  margin: 0 auto;
  font-family: 'Noto Sans Lao', 'Phetsarath OT', sans-serif;
}

@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

.page-header h1 { font-size: 24px; font-weight: 700; color: #0D1B2A; }
.page-header p { color: #4A5568; font-size: 14px; margin-top: 4px; }
.breadcrumb { display: flex; align-items: center; gap: 6px; font-size: 13px; color: #8898AA; margin-bottom: 8px; background: none; padding: 0; }
.breadcrumb span { color: #003F8A; font-weight: 600; }

.panel { background: #FFFFFF; border: 1px solid #E2E8F0; border-radius: 12px; overflow: hidden; }
.panel-head { padding: 16px 20px; border-bottom: 1px solid #E2E8F0; background: #fff; gap: 12px; }
.panel-head h3 { font-size: 16px; font-weight: 600; color: #0D1B2A; margin: 0; }

.search-box { position: relative; display: flex; align-items: center; }
.search-box i { position: absolute; left: 12px; color: #8898AA; font-size: 13px; }
.search-box input {
  padding: 8px 12px 8px 32px; border: 1px solid #E2E8F0; border-radius: 8px;
  font-size: 14px; width: 280px; max-width: 100%; outline: none; transition: border-color 0.2s;
  font-family: 'Noto Sans Lao', 'Phetsarath OT', sans-serif;
}
.search-box input:focus { border-color: #003F8A; }
.panel-body { padding: 24px; }

.school-card {
  display: flex; align-items: center; padding: 20px; border: 2px solid #F1F5F9;
  border-radius: 12px; cursor: pointer; transition: all 0.3s ease; background: white;
}
.school-card:hover { border-color: #003F8A; transform: translateY(-3px); box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1); }
.school-card.active { border-color: #003F8A; background-color: #F0F7FF; }

.school-icon { width: 50px; height: 50px; background: #E2E8F0; border-radius: 10px; display: flex; align-items: center; justify-content: center; margin-right: 15px; color: #003F8A; font-size: 20px; }
.school-card.active .school-icon { background: #003F8A; color: white; }

.school-info { flex: 1; }
.school-info h4 { font-size: 16px; font-weight: 700; margin: 0; color: #1E293B; }
.status-indicator { font-size: 20px; margin-left: 10px; }

/* Pagination */
.pagination-bar {
  display: flex; justify-content: space-between; align-items: center;
  flex-wrap: wrap; gap: 12px; margin-top: 20px; padding-top: 16px;
  border-top: 1px solid #F1F5F9;
}
.pagination-info { font-size: 13px; color: #64748B; }
.pagination-actions { display: flex; align-items: center; gap: 10px; }
.page-current { font-size: 13px; color: #0D1B2A; font-weight: 600; }
.page-btn {
  padding: 8px 16px; border: 1px solid #E2E8F0; background: #fff; color: #003F8A;
  border-radius: 8px; cursor: pointer; font-weight: 600; font-size: 13px;
  transition: all 0.2s; font-family: 'Noto Sans Lao', 'Phetsarath OT', sans-serif;
}
.page-btn:hover:not(:disabled) { background: #003F8A; color: #fff; border-color: #003F8A; }
.page-btn:disabled { opacity: 0.5; cursor: not-allowed; }
</style>
